module.exports = __webpack_public_path__ + "static/media/contest2025_third_place_image.5f7b2f82.jpeg";